import { render, staticRenderFns } from "./EventItemView.vue?vue&type=template&id=b46397ba&"
import script from "./EventItemView.vue?vue&type=script&lang=js&"
export * from "./EventItemView.vue?vue&type=script&lang=js&"
import style0 from "./EventItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports